import React from 'react';
import { ReactComponent as IconComponent } from '@THC/assets/svgs/arrow.svg';
import { Icon } from '../Icon/Icon';
const ArrowIcon = (props) => (<Icon {...props}>
		<IconComponent />
	</Icon>);
export const ArrowUpIcon = (props) => <ArrowIcon direction="up" {...props}/>;
export const ArrowDownIcon = (props) => <ArrowIcon direction="down" {...props}/>;
export const ArrowLeftIcon = (props) => <ArrowIcon direction="left" {...props}/>;
export const ArrowRightIcon = (props) => <ArrowIcon direction="right" {...props}/>;
